import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Navbar from "../../../components/Navbar";
import Background from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import style from "./Cameras.module.css";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const Cameras = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("moega01");

  const renderIframe = () => {
    const iframesMoega01 = [
      <div key="moega01-1" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera01moega&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>1 - Grelha</p>
      </div>,
      <div key="moega01-2" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera02moega&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>2 - Balança</p>
      </div>,
      <div key="moega01-3" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera03moega&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>3 - Carregamento</p>
      </div>,
      <div key="moega01-4" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera04moega&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>4 - Placas</p>
      </div>,
      <div key="moega01-5" className={style.iframeWrapper}>
      <iframe
        src="https://player.twitch.tv/?channel=camera05moega&parent=set.konexapp.com.br"
        frameBorder="0"
        allowFullScreen
        scrolling="no"
        height="378"
        width="620"
      ></iframe>
      <p>4 - Placas</p>
    </div>,
    <div key="moega01-6" className={style.iframeWrapper}>
    <iframe
      src="https://player.twitch.tv/?channel=moega01setportcam06&parent=set.konexapp.com.br"
      frameBorder="0"
      allowFullScreen
      scrolling="no"
      height="378"
      width="620"
    ></iframe>
    <p>4 - Placas</p>
  </div>,
    ];

    const iframesMoega02 = [
      <div key="moega02-1" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=moega02setportcam01&parent=set.konexapp.com.br&controls=false&muted=true"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
          className={style.noOverlay}
        ></iframe>
        <div className={style.overlay}></div>
        <p>1 - Grelha</p>
      </div>,
      <div key="moega02-2" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=moega02setportcam02&parent=set.konexapp.com.br&controls=false&muted=true"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
          className={style.noOverlay}
        ></iframe>
          <div className={style.overlay}></div>

        <p>2 - Balança</p>
      </div>,
      <div key="moega02-3" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=moega02setportcam03&parent=set.konexapp.com.br&controls=false&muted=true"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
          className={style.noOverlay}
        ></iframe>
          <div className={style.overlay}></div>

        <p>3 - Carregamento</p>
      </div>,
      <div key="moega02-4" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=moega02setportcam04&parent=set.konexapp.com.br&controls=false&muted=true"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
          className={style.noOverlay}
        ></iframe>
        <p>4 - Placas</p>
      </div>,
      <div key="moega02-5" className={style.iframeWrapper}>
      <iframe
        src="https://player.twitch.tv/?channel=moega02setportcam05&parent=set.konexapp.com.br&controls=false&muted=true"
        frameBorder="0"
        allowFullScreen
        scrolling="no"
        height="378"
        width="620"
        className={style.noOverlay}
      ></iframe>
      <p>5 - Speed Dome</p>
    </div>,
    <div key="moega02-6" className={style.iframeWrapper}>
    <iframe
      src="https://player.twitch.tv/?channel=moega02setportcam06&parent=set.konexapp.com.br&controls=false&muted=true"
      frameBorder="0"
      allowFullScreen
      scrolling="no"
      height="378"
      width="620"
      className={style.noOverlay}
    ></iframe>
    <p>6 - FIla de Carregamento</p>
  </div>,
    ];

    const iframesMoega03 = [
      <div key="moega03-1" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera01_moega03&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>1 - Grelha</p>
      </div>,
      <div key="moega03-2" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera02_moega03&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>2 - Balança</p>
      </div>,
      <div key="moega03-3" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera03_moega03&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>3 - Carregamento</p>
      </div>,
      <div key="moega03-4" className={style.iframeWrapper}>
        <iframe
          src="https://player.twitch.tv/?channel=camera04_moega03&parent=set.konexapp.com.br"
          frameBorder="0"
          allowFullScreen
          scrolling="no"
          height="378"
          width="620"
        ></iframe>
        <p>4 - Placas</p>
      </div>,
    ];

    switch (activeTab) {
      case "moega01":
        return <div className={style.iframeGrid}>{iframesMoega01}</div>;
      case "moega02":
        return <div className={style.iframeGrid}>{iframesMoega02}</div>;
      case "moega03":
        return <div className={style.iframeGrid}>{iframesMoega03}</div>;
      default:
        return null;
    }
  };

  return (
    <>
      <Navbar />
      <Header />
      <Background />
      <Container>
        <br />
        <div className={style.content}>
        <div className={style.tabContainer}>
          <button
            className={`${style.tabButton} ${activeTab === "moega01" ? style.active : ""}`}
            onClick={() => setActiveTab("moega01")}
          >
            Moega 01
          </button>
          <button
            className={`${style.tabButton} ${activeTab === "moega02" ? style.active : ""}`}
            onClick={() => setActiveTab("moega02")}
          >
            Moega 02
          </button>
          <button
            className={`${style.tabButton} ${activeTab === "moega03" ? style.active : ""}`}
            onClick={() => setActiveTab("moega03")}
          >
            Moega 03
          </button>
        </div>
        <div className={style.iframeContainer}>{renderIframe()}</div>
        </div>
      </Container>
    </>
  );
};

export default Cameras;
